import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../../dealer-details/dealer-details.component';
import {ExcSigninService} from 'exc-signin';
import {ProviderDealerDetailsComponent} from '../../provider/provider-dealer-details/provider-dealer-details.component';

@Component({
  selector: 'dealer-waffle',
  templateUrl: './dealer-waffle.component.html',
  styles: []
})
export class DealerWaffleComponent extends ExcTranslation implements OnInit {

  @Input('Dealer') Dealer;
  @Input('showDealerLink') showDealerLink = false;
  constructor(private excDss: DefaultSettingsService, private excSec: ExcSigninService) {
    super();
  }

  openDealer() {
    if (this.excSec.isFeatured('PRV')) {
      new ExcTab(this.Dealer.DealerName, ProviderDealerDetailsComponent, this.Dealer, this.Dealer.DealerID,
      {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    } else if (this.excSec.isFeatured('CLI')) {
      new ExcTab(this.Dealer.DealerName, DealerDetailsComponent, this.Dealer, this.Dealer.DealerID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    }
  }
  ngOnInit() {
  }

  textProcess (text) {

    const re = /\,/gi;
    return  text.replace(re, ', ');
  }

}
